import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QualityInternationalForm, QualityInternationalFormGroup } from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { MaterialDisposition } from '@cod-monorepo/interfaces';
import { AddCurrentCodLine } from '../../../state/cod.action';
import { Store } from '@ngxs/store';
import { BaseInternationalStep } from '../base-international-step/base-international-step';

@Component({
    selector: 'app-cod-quality-international-step',
    templateUrl: './quality-international.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent
    ],
    standalone: true
})
export class CodQualityInternationalStepComponent extends BaseInternationalStep {
    @Input() qualityInternationalForm: FormGroup<QualityInternationalFormGroup> | undefined;

    public materiaDispositions = MaterialDisposition;

    constructor(private store: Store) {
        super();
    }

    public isDefined(control: keyof QualityInternationalForm): boolean {
        return this.qualityInternationalForm?.controls[control].value !== null;
    }

    public handleConfirm() {
        if (this.qualityInternationalForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.qualityInternationalForm?.valid ?? false;
    }
}
